import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

// manor
import { Typography } from '@comparethemarketau/manor-typography';

const useStylesQuoteReference = createUseStyles((theme) => ({
    quoteReferenceContainer: {
        backgroundColor: theme.colors.primary50,
        padding: {
            top: '1.4rem',
            bottom: '1.4rem',
            left: '1rem'
        }
    }
}));

const QuoteReference = (props) => {
    const { quoteNumber } = props;
    const theme = useContext(ThemeContext);
    const classes = useStylesQuoteReference({ theme });

    return (
        <div className={classes.quoteReferenceContainer}>
            <Typography>
                {'Quote reference: '}
                <Typography variant="subtitle2" component="span">{quoteNumber}</Typography>
            </Typography>
        </div>
    );
};

QuoteReference.propTypes = {
    quoteNumber: PropTypes.string.isRequired
};

export { QuoteReference };
